import { createColorPalette, finalizeColorPalette } from "./colorPalette";
export { createColorPalette, finalizeColorPalette };
export default createColorPalette;
